<template>
  <div id="page-content" tabindex="-1" class="mx-auto">
    <span aria-label="Select DMV Office Location Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mb-5" :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.selectLocationSelectDMVLocation }}
    </h2>
    <div class="pb-2" :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.selectLocationpleaseSelectaPreferedLocation }}
    </div>
    <div v-if="errorMessage">
      <p class="red--text" :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ errorMessage }}
      </p>
    </div>
    <div class="location-container px-4">
      <v-expansion-panels>
        <v-expansion-panel v-for="county in locationCounties" :key="county.CountyId" class="panel-margin">
          <v-expansion-panel-header hide-actions class="white--text public-h6"
            :class="isRTLLanguage ? 'rtl' : 'normal'">
            <template v-slot:default="{ open }">
              <div style="width: 100%" :class="isRTLLanguage ? 'right' : ''">
                {{ formatCountyName(county.County) }}
              </div>
              <div>
                <v-icon color="white">
                  <template v-if="open">mdi-minus</template>
                  <template v-else>mdi-plus</template>
                </v-icon>
              </div>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5" :class="isRTLLanguage ? 'right' : ''">
            <v-card class="mb-5" v-for="location in county.Locations" :key="location.Id">
              <v-card-text>
                <div class="pb-1 font-weight-bold">
                  {{ location.Name }}
                </div>
                <div class="pb-2">{{ location.Address }}</div>
                <!-- <div>
                  {{ siteText.ui.selectLocationNextDate }}
                  {{ location.NextAvailableDate }}
                </div> -->
                <!-- <div class="pt-4"> -->
                <!-- </div> -->
              </v-card-text>
              <v-btn class="ma-2 dmv-btn loc-btn" @click="onLocationSelected(location)">{{
                    siteText.ui.selectLocationSelect }}
                {{ location.Name }}</v-btn>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="text-left nav-div">
      <v-layout row wrap>
        <v-flex md3>
          <v-btn class="ma-2 dmv-btn" height="45px" width="260px" @click="back()"><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.selectAllLocationsBack }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    locationCounties: [],
    errorMessage: "",
  }),
  computed: {
    ...mapGetters([
      "siteText",
      "reschedule",
      "availableLocationsByCounty",
      "availableLocationsByCounty",
    ]),
    ...mapGetters("selectedService", [
      "selectedServiceTypeId",
      "selectedServiceTypeId2",
    ]),
    ...mapGetters(["isRTLLanguage"]),
  },
  methods: {
    ...mapActions([
      "getLocationsByCountyWithServiceType",
      "getLocationByLocationId",
      "selectLocation",
      "setAvailableLocationsByCounty",
      "setAvailableLocationsByCounty",
    ]),
    onLocationSelected(location) {
      console.log(location);
      this.selectLocation(location);
      this.$emit("navigateTo", "SelectDateTimePage", {
        pageName: "Select Reservation Date and Time",
      });
    },
    formatCountyName(county) {
      let newCounty = county + " County";
      const firstParen = county.indexOf("(");
      if (firstParen > 0) {
        newCounty =
          county.substring(0, firstParen) +
          "County " +
          county.substring(firstParen, county.length);
      }
      return newCounty;
    },
    back() {
      const backPage = !this.reschedule
        ? "SelectServicePage"
        : "RescheduleReservationPage";
      const pageName = !this.reschedule
        ? "Select Service for Reservation"
        : "Current Reservation";
      this.$emit("navigateTo", backPage, {
        pageName: pageName,
      });
    },
    getUrlParameter(name) {
      name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
  },
  async mounted() {
    //Get all locations with selected service type//
    this.errorMessage = "";
    if (
      !this.availableLocationsByCounty ||
      this.availableLocationsByCounty.length === 0
    ) {
      const typeId = this.selectedServiceTypeId;
      const typeId2 = this.selectedServiceTypeId2;
      const locationId = this.getUrlParameter('locationid');
      
      try {
        let locationCounties;
        if (locationId) {
          locationCounties = await this.getLocationByLocationId(
            { serviceTypeId: typeId, serviceTypeId2: typeId2, locationId: locationId }
          );
        } else {
          locationCounties = await this.getLocationsByCountyWithServiceType(
            { serviceTypeId: typeId, serviceTypeId2: typeId2 }
          );
        }
        console.log(locationCounties);
        this.locationCounties = locationCounties;
        this.setAvailableLocationsByCounty(locationCounties);

        if (this.locationCounties.length <= 0) {
          this.errorMessage = this.siteText.errors.noAvailability;
        }
      } catch {
        this.errorMessage = "Failed to retrieve available locations.";
      }
    } else {
      this.locationCounties = this.availableLocationsByCounty;
    }
  },
};
</script>

<style>
.panel-margin {
  margin-top: 15px !important;
}

.v-expansion-panel-header {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.nav-div {
  padding-top: 100px;
  margin-left: 20px;
}

.loc-btn {
  height: 45px;
  max-width: 350px !important;
}

@media screen and (max-width: 400px) {
  .loc-btn {
    width: 230px !important;
  }
}
</style>
